import { createEntityCollectionStore } from '@recruitee/ngrx';

import { AdpAdmin } from '../../../types';

const { actions, namespace, selectors, reducer } = createEntityCollectionStore<AdpAdmin>()(
  'AdpAdmin',
  {
    idSelector: (entity: { associateOid: string }) => entity.associateOid,
  },
);

export {
  actions as AdpAdminActions,
  namespace as AdpAdminNamespace,
  reducer as AdpAdminReducer,
  selectors as AdpAdminSelectors,
};
